function initializeFaq() {
  new FaqActions().addHandlers();
}

$(initializeFaq);
$(document).on("turbo:load", initializeFaq);

var FaqActions = function() {
  var obj = this;

  obj.addHandlers = function() {
    // Use namespaced events to prevent duplicate handlers on turbo:load + ready
    $(".faq-question").off("click.faq").on("click.faq", function() {
      obj.toggleAnsver($(this).closest(".faq-question-answer-wrapper"));
      return false;
    });

    $(".services-plan-faq-anchor").off("click.faq").on("click.faq", function() {
      obj.planToFaq($(this).attr("id"));
      return false;
    });
  };

  obj.toggleAnsver = function($questionBlock) {
    if(!$questionBlock.hasClass("active")) {
      obj.openAnsver($questionBlock);
    } else {
      obj.closeAnsver($questionBlock);
    }
  };

  obj.openAnsver = function($questionBlock) {
    $questionBlock.addClass("active");
    $questionBlock.find("a").attr("aria-expanded", "true");
    $questionBlock.find(".faq-answer-wrapper").stop().slideDown(200);
    obj.setAnchor($questionBlock.find('a').attr("href"));
  };

  obj.closeAnsver = function($questionBlock) {
    $questionBlock.removeClass("active");
    $questionBlock.find("a").attr("aria-expanded", "false");
    $questionBlock.find(".faq-answer-wrapper").stop().slideUp(200);
    obj.setAnchor(' ');
  };

  obj.planToFaq = function(linkId) {
    var $answer = $("."+linkId);
    obj.openAnsver($answer);
    obj.scrollToElement($answer);
  };

  obj.scrollToElement = function($element) {
    /* global SmoothAnchorSchroll */
    new SmoothAnchorSchroll().scrollTo($element, function() {
      $element.find("a").focus();
    });
  }

  obj.setAnchor = function(anchor) {
    // Use space to remove anchor from URL (empty string doesn't work)
    history.replaceState(history.state, '', anchor || ' ');
  }

};
